import { Stack, styled, Typography } from '@mui/material';
import { useInjection } from './hook';
import { TabsCustom } from '../../components/elements/TabsCutom';
import React, { useCallback, useMemo } from 'react';
import { headerTabRoom, TabRoom } from 'const/room';
import { ComponentRoomPage } from '../../components/RoomPage/ComponentRoomPage';
import { HeaderClient } from '../Clients/conponents/HeaderClient';
import { ModalGenerateReport } from '../../components/RoomPage/modalGenReport';
import { TabDocuments } from '../../components/RoomPage/TabDocuments';
import { DialogConfirm } from '../../components/elements/DialogConfirm';
import { ModalAddAppendix } from '../../components/RoomPage/modalAddAppendix';
import { ModalViewAllAppendix } from '../../components/RoomPage/modalViewAllAppendix';
import { AssetIssues } from 'types/room';
import { ModalStartInspection } from '../../components/RoomPage/ModalStartInspection';
import { ModalCreateAssetEntryForm } from '../../components/RoomPage/ModalCreateAssetEntryForm';

export const RoomPage = () => {
  const {
    // === Paging, Params, Filter ===
    searchParams,
    tab,
    archiveFilter,
    setArchiveFilter,
    archiveReportFilter,
    setArchiveReportFilter,

    // === Tabs & Table View ===
    onChangeTab,
    tabTable,
    setTabTable,
    roomAssetExpandedId,
    setRoomAssetExpandedId,

    // === Search & Sort ===
    searchText,
    onSearch,
    handleSort,
    sortOption,

    // === Paging ===
    pagingAssetIssues,
    pagingDocument,
    pagingIssuesTab,

    // === Asset Issues ===
    assetIssues,
    setAssetIssues,
    optionIssues,
    handleFetchMoreIssues,
    hasMoreIssues,
    handleChangePage,
    handleDeleteAsset,
    deleteAsset,
    setDeleteAsset,
    onDeleteAsset,
    issuesStatus,
    setIssuesStatus,

    // === Room ===
    room,
    paths,

    // === Image Asset Handling ===
    asyncUpdateImageAsset,
    asyncGetInitFileAsset,
    handleSetImageSelected,
    imageSelected,

    // === Filter Asset Type ===
    onFilterAssetType,
    valueFilterAssetType,
    optionFilterAssetType,
    hasMoreOptionType,
    handleFetchMoreOptionType,
    optionAssetSelect,

    // === Documents ===
    documentFile,

    // === Documents Generate===
    documentGenerate,

    // === Reports ===
    reports,
    setReports,
    openModalGenerateReport,
    setOpenModalGenerateReport,
    onCloseModalGenerateReport,
    onSubmitModalGenerateReport,
    onRefreshReportIssue,

    // === Appendices ===
    itemEditAppendices,
    setItemEditAppendices,
    handleDeleteAppendix,
    handleFetchMoreAppendix,
    idDeleteAppendices,
    setIdDeleteAppendices,
    asyncSubmitModalEditAppendix,
    optionAppendix,
    hasMoreOptionAppendix,

    // === PDF/File Selection ===
    optionFilePdf,
    hasMoreOptionFilePdf,
    handleFetchMoreFilePdf,

    // === Modals (Appendices) ===
    openModalAddAppendix,
    setOpenModalAddAppendix,
    openModalViewAllAppendix,
    setOpenModalViewAllAppendix,
    onClickLinkModalAddAppendix,
    onCloseModalAddAppendix,
    onSubmitModalAddAppendix,

    // === Frequency ===
    frequencyOptions,
    onUpdateRoom,
    // filter by criticality
    selectedCriticality,
    onFilterCriticality,

    handleFilterAssets,
    filterAssets,

    maintainanceSelectedDate,
    setSelectedMaintainanceDate,
    maintainanceSelectedType,
    setSelectedMaintainanceType,
    searchType,
    setSearchType,
    asyncDeleteDocument,
    // start inspection
    openInspection,
    setOpenInspection,
    openAssetForm,
    setOpenAssetForm,
    roomDetail,
    onRefreshDataAssets,
    asyncHandleGetLocationLevelFive
  } = useInjection();
  const optionRoomLevelIssues = useMemo(() => {
    if (!room) return [];
    return (
      room.roomLevelIssues
        .filter((item) => !item.archivedAt)
        .map((item) => ({
          value: item.id.toString(),
          label: item.options?.[0]?.value + ` - ${item.description}`
        })) || []
    );
  }, [room]);
  const renderTab = useCallback(() => {
    const tab = searchParams.get('tab') || TabRoom.RoomAttributes;
    if (tab === TabRoom.RoomAttributes && room) {
      return (
        <ComponentRoomPage
          reFreshRoomLevelIssues={() => asyncHandleGetLocationLevelFive(roomDetail?.id)}
          setOpenAssetForm={setOpenAssetForm}
          setIssuesStatus={setIssuesStatus}
          issuesStatus={issuesStatus}
          archiveReportFilter={archiveReportFilter}
          setArchiveReportFilter={setArchiveReportFilter}
          setOpenModalAddAppendix={setOpenModalAddAppendix}
          searchTextAsset={searchText.roomAttributes}
          searchTextIssues={searchText.issuesTab}
          tabTable={tabTable}
          setTabTable={setTabTable}
          roomAssetExpandedSubmittedAssetId={roomAssetExpandedId}
          onRoomAssetExpandedSubmittedAssetChange={setRoomAssetExpandedId}
          dataTableReports={reports}
          archiveFilter={archiveFilter}
          setArchiveFilter={setArchiveFilter}
          setAssetIssues={setAssetIssues}
          imageSelected={imageSelected}
          handleSetImageSelected={handleSetImageSelected}
          optionFilterAssetIssue={optionAssetSelect}
          hasMore={hasMoreOptionType}
          handleFetchMore={handleFetchMoreOptionType}
          onSearch={onSearch}
          onFilterAssetType={onFilterAssetType}
          valueFilterAssetType={valueFilterAssetType}
          optionFilterAssetType={optionFilterAssetType}
          setOpenModalGenerateReport={setOpenModalGenerateReport}
          updateLogoAsset={asyncUpdateImageAsset}
          handleRefresh={asyncGetInitFileAsset}
          handleRefreshReport={onRefreshReportIssue}
          assetIssues={assetIssues}
          room={room}
          setReports={setReports}
          handleChangePage={handleChangePage}
          pagingInfo={pagingAssetIssues}
          pagingInfoTabIssues={pagingIssuesTab}
          handleSort={handleSort}
          sortOption={sortOption}
          handleDeleteAsset={handleDeleteAsset}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          frequencyOptions={frequencyOptions as any}
          onUpdateRoom={onUpdateRoom}
          selectedCriticality={selectedCriticality}
          onFilterCriticality={onFilterCriticality}
          handleFilterAssets={handleFilterAssets}
          filterAssets={filterAssets}
          maintainanceSelectedType={maintainanceSelectedType}
          maintainanceSelectedDate={maintainanceSelectedDate}
          setSelectedMaintainanceType={setSelectedMaintainanceType}
          setSelectedMaintainanceDate={setSelectedMaintainanceDate}
          searchType={searchType}
          setSearchType={setSearchType}
        />
      );
    }
    return (
      <TabDocuments
        handleChangePage={handleChangePage}
        pagingInfo={pagingDocument}
        handleSort={handleSort}
        sortOption={sortOption}
        onSearch={onSearch}
        searchValue={searchText.documentation}
        dataDocuments={documentFile}
        handleDelete={asyncDeleteDocument}
      />
    );
  }, [
    searchParams,
    room,
    handleChangePage,
    pagingDocument,
    handleSort,
    sortOption,
    onSearch,
    documentFile,
    asyncDeleteDocument,
    setOpenAssetForm,
    setIssuesStatus,
    issuesStatus,
    archiveReportFilter,
    setArchiveReportFilter,
    setOpenModalAddAppendix,
    searchText.roomAttributes,
    searchText.documentation,
    searchText.issuesTab,
    tabTable,
    setTabTable,
    roomAssetExpandedId,
    setRoomAssetExpandedId,
    reports,
    archiveFilter,
    setArchiveFilter,
    setAssetIssues,
    imageSelected,
    handleSetImageSelected,
    optionAssetSelect,
    hasMoreOptionType,
    handleFetchMoreOptionType,
    onFilterAssetType,
    valueFilterAssetType,
    optionFilterAssetType,
    setOpenModalGenerateReport,
    asyncUpdateImageAsset,
    asyncGetInitFileAsset,
    onRefreshReportIssue,
    assetIssues,
    setReports,
    pagingAssetIssues,
    pagingIssuesTab,
    handleDeleteAsset,
    frequencyOptions,
    onUpdateRoom,
    selectedCriticality,
    onFilterCriticality,
    handleFilterAssets,
    filterAssets,
    maintainanceSelectedType,
    maintainanceSelectedDate,
    setSelectedMaintainanceType,
    setSelectedMaintainanceDate,
    searchType,
    setSearchType,
    asyncHandleGetLocationLevelFive,
    roomDetail?.id
  ]);
  return (
    <WrapperCreatePage>
      <HeaderClient
        isCanAccessRoom
        textButton={room ? '' : 'Start Inspection'}
        onClickButton={() => {
          setOpenInspection(true);
        }}
        paths={paths || []}
      />
      {!room && roomDetail && (
        <ModalStartInspection
          onRefresh={() => asyncHandleGetLocationLevelFive(roomDetail?.id)}
          roomDetail={roomDetail}
          open={openInspection}
          onClose={() => setOpenInspection(false)}
        />
      )}
      {room && roomDetail && (
        <ModalCreateAssetEntryForm
          submittedId={room.id}
          onRefresh={() => onRefreshDataAssets()}
          roomDetail={roomDetail}
          open={openAssetForm}
          onClose={() => setOpenAssetForm(false)}
        />
      )}
      {!room ? (
        <Typography fontSize={22} fontWeight={700}>
          There is no inspection in this room.
        </Typography>
      ) : (
        <>
          <TabsCustom
            contentTab={renderTab()}
            tab={Number(tab) || 0}
            headerTab={headerTabRoom}
            onChangeTab={onChangeTab}
          />
          <ModalGenerateReport
            documentGenerate={documentGenerate}
            optionRoomLevelIssues={optionRoomLevelIssues}
            optionIssues={optionIssues}
            handleFetchMoreIssues={handleFetchMoreIssues}
            hasMoreIssues={hasMoreIssues}
            optionAsset={
              optionAssetSelect?.map((item: AssetIssues) => ({
                label: `${item?.name} - ${item?.type?.name} - ${item?.issueReports?.length ? `${item?.issueReports?.length} issues` : 'no issues'}`,
                value: item.id.toString()
              })) || []
            }
            onCloseModal={onCloseModalGenerateReport}
            onCancel={onCloseModalGenerateReport}
            onSubmit={onSubmitModalGenerateReport}
            isOpen={openModalGenerateReport}
          />
        </>
      )}
      <DialogConfirm
        isOpen={Boolean(deleteAsset)}
        onClose={() => setDeleteAsset(undefined)}
        textTitle="Delete Location"
        textContent={`Are you sure you want to delete this Asset ${deleteAsset?.name}?`}
        onSubmit={onDeleteAsset}
        textButton={'Delete'}
      />
      <ModalAddAppendix
        isCreate
        handleFetchMore={handleFetchMoreFilePdf}
        hasMore={hasMoreOptionFilePdf}
        onCancel={onCloseModalAddAppendix}
        optionFile={optionFilePdf}
        onSubmit={onSubmitModalAddAppendix}
        onClickLink={onClickLinkModalAddAppendix}
        isOpen={openModalAddAppendix}
        onCloseModal={onCloseModalAddAppendix}
      />
      <ModalAddAppendix
        handleFetchMore={handleFetchMoreFilePdf}
        hasMore={hasMoreOptionFilePdf}
        onCancel={() => setItemEditAppendices(null)}
        optionFile={optionFilePdf}
        onSubmit={asyncSubmitModalEditAppendix}
        isOpen={!!itemEditAppendices?.id}
        onCloseModal={() => setItemEditAppendices(null)}
        initValue={itemEditAppendices}
      />
      <ModalViewAllAppendix
        setItemEditAppendices={setItemEditAppendices}
        setIdDeleteAppendices={setIdDeleteAppendices}
        handleFetchMore={handleFetchMoreAppendix}
        hasMore={hasMoreOptionAppendix}
        optionAsset={optionAppendix}
        onCloseModal={() => setOpenModalViewAllAppendix(false)}
        onCancel={() => setOpenModalViewAllAppendix(false)}
        isOpen={openModalViewAllAppendix}
      />
      <DialogConfirm
        textTitle={'Delete Appendix'}
        textContent={`Are you sure you want to delete  Appendix ${idDeleteAppendices} ?`}
        textButton={'Delete'}
        isDelete
        onSubmit={handleDeleteAppendix}
        isOpen={!!idDeleteAppendices}
        onClose={() => setIdDeleteAppendices(null)}
      />
    </WrapperCreatePage>
  );
};
const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh',
  gap: '20px'
}));
